$(document).ready(function () {

  /* home banner*/
  $(".js-hmbanner").slick({
    autoplay:true,
    slidesToShow: 1,
    arrows:false,
    fade: true,
    dots:true,
			responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows:false,
        }
      }
      ]
  }); 


	//Best sellers slider
	   $('.sec-featured .product-list').slick({
      arrows: true,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      horizontal: true,
      infinite: false,
      autoplay: false,
      pauseOnHover: false,
      autoplaySpeed: 3000,
      responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint:375,
        settings: {
          slidesToShow: 1,
          centerMode:true,
          centerPadding:'50px',
        }
      }
      ]
  });

  /* Shop Aquaman Pool */
  $(".equipment-ul").slick({
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow:5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2500,
    responsive: [{
      breakpoint: 1440,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
      },
     {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        
      }
    }]
  });

  /*------ key feature ------*/

  function applyJQueryBasedOnScreenSize() {
    const mediaQuery = window.matchMedia("(max-width: 1600px)");
    if (mediaQuery.matches) {
      $('.trust-factor-ul').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        autoplay: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 3,
          }
        },
				{
          breakpoint:1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            
          },
        },
        {
          breakpoint:768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            
          },
        },
				{
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerPadding: '80px',
            centerMode: true,
          },
        }, 
				{
          breakpoint: 481,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '80px',
            centerMode: true,
          },
        }]
      });
      
    } 
    else
    {
       if ($(".trust-factor-ul").hasClass("slick-initialized")) {
         $(".trust-factor-ul").slick("unslick")
       }
    }
  }
  applyJQueryBasedOnScreenSize();
  let resizeTimeout;
  $(window).on("resize", function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(applyJQueryBasedOnScreenSize, 200)
  });


 
});

